import React from 'react';
import { getStatCards } from '../../admin/bid-center/utils';
import { formatValue, formatCurrencyThousands } from '../common/utils';
import { getClass } from 'utils/component-helpers';

import arrowRedDownIcon from '../../../images/icons/icon-arrow-red-down.svg';
import checkMarkIcon from '../../../images/icons/icon-checkmark.svg';
import './stat-cards.scss';

const StatCards = ({ data, statType }) => {
	const format = (card, cardStats, cardStatType) => {
		if (statType === 'merchant-performance-overview') {
			if (card.name === 'roas') {
				if (['goal', 'projected'].includes(cardStatType)) return '-';
				if (cardStatType === 'current') return parseFloat(cardStats[cardStatType]).toFixed(1);
			}
			if (card.name === 'revenue' && cardStatType === 'goal') return '-';
			if (cardStatType === 'current' && parseInt(cardStats[cardStatType]) === 0) {
				if (['spend', 'revenue'].includes(card.name)) return '$0';
				if (card.name === 'roas') return '0.0';
			}
		}
		const cardFullName = `${card.name + '_' + cardStatType}`;
		const cardType = cardStatType === 'percent_difference' ? 'percent' : card.type;
		const val = cardStatType === 'current' && ['revenue', 'spend'].includes(card.name)
			? parseFloat(cardStats[cardStatType]).toFixed(1)
			: cardStats[cardStatType];
		const formattedValue = formatValue(val, cardType, cardFullName, true);
		return cardType === 'currency' && formattedValue !== '-'
			? formatCurrencyThousands(formattedValue, cardStatType === 'current' ? 'K' : null)
			: formattedValue;
	};

	return (
		<div className="stat-cards">
			{getStatCards(statType).map((card, index) => {
				// TODO: Set data to goals if business decides we don't need the other values in totals
				const cardStats = data.goals.filter((goal) => goal.name === card.name)[0];
				const positivePercent = parseInt(cardStats.percent_difference) > 0;
				const onPace = parseInt(cardStats.projected) >= parseInt(cardStats.goal);

				const percentDifference = format(card, cardStats, 'percent_difference');
				const projected = format(card, cardStats, 'projected');
				const goal = format(card, cardStats, 'goal');

				const paceImg = <img src={onPace ? checkMarkIcon : arrowRedDownIcon} alt={onPace.toString()} />;
				const paceIcon = goal !== '-' && statType !== 'merchant-performance-overview'
					? paceImg
					: null;
				const paceIcon2 = goal !== '-' && statType === 'merchant-performance-overview'
					? paceImg
					: null;

				const targetText = card.name === 'spend' && statType === 'merchant-performance-overview'
					? 'Merchant Monthly Target'
					: 'Target';

				const pacing = card.name === 'roas' ? (
					<div className="pacing">
						<span className="value">
							{projected}
						</span>
						% from Target&nbsp;
					</div>
				) : (
					<div className="pacing">
						Pacing towards&nbsp;
						<span className="value">
							{projected}
						</span>
					</div>
				);

				return (
					<div
						key={index}
						className={`card ${cardStats.name}`}>
						<div className="label-current-percent">
							<p>{card.label}</p>
							<p className="value">
								{format(card, cardStats, 'current')}
							</p>
							<div className="percent-difference">
								<span className={getClass('value', {
									'green': positivePercent,
									'red': !positivePercent,
								})}>
									{`
										${positivePercent ? '+' : ''}
										${percentDifference}
									`}
								</span>
								<span className="from-last-month">(from last month)</span>
							</div>
						</div>
						<div className="target-pacing">
							{pacing}
							{paceIcon2}
							<div className="line">|</div>
							<div className="target">
								{targetText}:&nbsp;
								<span className="value">
									{goal}
								</span>
								{paceIcon}
							</div>
						</div>
					</div>
				);
			})}
		</div>
	);
};

export default StatCards;
